import { Container, Form, Button, Alert, Modal, Badge, Card, Row, Col } from "react-bootstrap";
import { useState, useRef, useEffect } from "react";
import { sendAffiliazione } from "../api/api.js";

// Dati bancari fittizi (modifica con quelli reali quando li hai)
const BANK_DETAILS = {
  beneficiario: "ASD FREE SPORT AND MOVEMENT",
  banca: "Banca Prealpi",
  iban: "IT34Y0890462030023000001402",
  importo: "60.00", 
  note: "Affiliazione WKA"
};

function generateCausale(nomeSocieta) {
  const now = new Date();
  const formattedDate = now.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
  const safeNome = nomeSocieta || "SOCIETA";
  return `Affiliazione ${safeNome} in data ${formattedDate}`;
}


export default function Affiliazione() {
  const initialData = {
    nome_societa: "",
    indirizzo: "",
    comune: "",
    numero: "",
    provincia: "",
    cf_piva: "",
    nome_presidente: "",
    data: "",
    discipline: [],
    lista_atleti: [],
    ente_precedente: "",
    gia_affiliato: false,
    firma: null,
  };

  const [formData, setFormData] = useState(initialData);
  const [newAtleta, setNewAtleta] = useState("");
  const [newDisciplina, setNewDisciplina] = useState("");
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("confirm"); // "confirm" | "success"

  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const lastPos = useRef({ x: 0, y: 0 });
  const scaleRef = useRef(1);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const scale = window.devicePixelRatio || 1;
    scaleRef.current = scale;
    const width = canvas.parentElement.offsetWidth || 600;
    const height = 300;
    canvas.width = Math.floor(width * scale);
    canvas.height = Math.floor(height * scale);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.scale(scale, scale);
    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
        ente_precedente: checked ? prev.ente_precedente : "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const addItem = (field, value) => {
    if (!value || !value.trim()) return;
    setFormData((prev) => ({ ...prev, [field]: [...prev[field], value.trim()] }));
    if (field === "lista_atleti") setNewAtleta("");
    if (field === "discipline") setNewDisciplina("");
  };

  const removeItem = (field, index) => {
    setFormData((prev) => ({
      ...prev,
      [field]: prev[field].filter((_, i) => i !== index),
    }));
  };

  const getPosition = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const point = e.touches ? e.touches[0] : e;
    return { x: point.clientX - rect.left, y: point.clientY - rect.top };
  };

  const startDrawing = (e) => {
    e.preventDefault();
    lastPos.current = getPosition(e);
    setDrawing(true);
  };

  const draw = (e) => {
    if (!drawing) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const newPos = getPosition(e);
    ctx.lineWidth = 2;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#000";
    ctx.beginPath();
    ctx.moveTo(lastPos.current.x, lastPos.current.y);
    ctx.lineTo(newPos.x, newPos.y);
    ctx.stroke();
    lastPos.current = newPos;
  };

  const endDrawing = (e) => {
    e && e.preventDefault();
    setDrawing(false);
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    // cancella considerando la dimensione reale del canvas
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // ripristina scala
    const scale = scaleRef.current || 1;
    ctx.scale(scale, scale);
  };

  // nuovo stato
  const [modalMessage, setModalMessage] = useState(null);

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setModalMessage("Copiato negli appunti");
      setTimeout(() => setModalMessage(null), 1000);
    } catch {
      setModalMessage("Copia fallita");
      setTimeout(() => setModalMessage(null), 1500);
    }
  };

  const downloadBonifico = (text) => {
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "bonifico.txt";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setMessage(null);

    try {
      let blob = null;
      if (canvasRef.current) {
        // assicura che esista toBlob
        blob = await new Promise((resolve) => {
          const cnv = canvasRef.current;
          if (cnv.toBlob) return cnv.toBlob(resolve, "image/png");
          // fallback: create blob from dataURL
          const dataUrl = cnv.toDataURL("image/png");
          const byteString = atob(dataUrl.split(",")[1]);
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
          resolve(new Blob([ab], { type: "image/png" }));
        });
      }

      const data = new FormData();
      for (let key in formData) {
        if (key === "firma") continue;
        const value = formData[key];
        if (Array.isArray(value)) data.append(key, value.join(", "));
        else if (typeof value === "boolean") data.append(key, value ? "true" : "false");
        else if (value) data.append(key, value);
      }

      if (blob) data.append("firma", blob, "firma.png");

      const res = await sendAffiliazione(data);

      if (res.ok) {
        setMessage(res.message || "Richiesta inviata con successo!");
        setMessageType("success");
        // reset del form
        setFormData(initialData);
        clearCanvas();
        // prepara modal success con dati bonifico
        setModalType("success");
        setShowModal(true);
      } else {
        setMessage(res.error || "Errore nell'invio");
        setMessageType("danger");
      }
    } catch (e) {
      console.error("Errore durante l'invio:", e);
      setMessage("Errore di rete durante l'invio");
      setMessageType("danger");
    } finally {
      setLoading(false);
      // se l'invio è andato a buon fine abbiamo già mostrato il modal success
      // altrimenti chiudiamo il confirm modal
      if (modalType === "confirm" && !showModal) setShowModal(false);
    }
  };

  // composizione testo bonifico
  const getBonificoText = (causale) => {
    return [
      `Intestatario: ${BANK_DETAILS.beneficiario}`,
      `Banca: ${BANK_DETAILS.banca}`,
      `IBAN: ${BANK_DETAILS.iban}`,
      `Importo: € ${BANK_DETAILS.importo}`,
      `Causale: ${causale}`,
      ``,
      `Note: ${BANK_DETAILS.note}`,
    ].join("\n");
  };

  // quando si apre il modal success, generiamo la causale visibile
  const causaleForModal = generateCausale(formData.nome_societa);

  return (
    <Container className="mt-4 mb-5 d-flex justify-content-center">
      <Card className="shadow-lg border-0 p-4 rounded-4 w-100" style={{ maxWidth: "700px" }}>
        <h2 className="text-center mb-4 text-primary fw-bold">Affiliazione Società WKA</h2>

        {message && (
          <Alert variant={messageType} dismissible onClose={() => setMessage(null)}>
            {message}
          </Alert>
        )}

        <Form>
          <h5 className="mb-3 text-secondary border-bottom pb-1">Dati della Società</h5>
          <Row className="g-2">
            <Col xs={12} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nome Società *</Form.Label>
                <Form.Control type="text" name="nome_societa" value={formData.nome_societa} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nome Presidente *</Form.Label>
                <Form.Control type="text" name="nome_presidente" value={formData.nome_presidente} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-2">
            <Col xs={12} md={8}>
              <Form.Group className="mb-3">
                <Form.Label>Indirizzo *</Form.Label>
                <Form.Control type="text" name="indirizzo" value={formData.indirizzo} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col xs={12} md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Numero *</Form.Label>
                <Form.Control type="text" name="numero" value={formData.numero} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>

          <Row className="g-2">
            <Col xs={12} md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Comune *</Form.Label>
                <Form.Control type="text" name="comune" value={formData.comune} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col xs={12} md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Provincia *</Form.Label>
                <Form.Control type="text" name="provincia" value={formData.provincia} onChange={handleChange} />
              </Form.Group>
            </Col>
            <Col xs={12} md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Data *</Form.Label>
                <Form.Control type="date" name="data" value={formData.data} onChange={handleChange} />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-4">
            <Form.Label>Codice Fiscale / P.IVA *</Form.Label>
            <Form.Control type="text" name="cf_piva" value={formData.cf_piva} onChange={handleChange} />
          </Form.Group>

          <h5 className="text-secondary border-bottom pb-1 mb-3">Discipline praticate</h5>
          <div className="d-flex flex-wrap gap-2 mb-2">
            <Form.Control type="text" placeholder="Inserisci disciplina" value={newDisciplina} onChange={(e) => setNewDisciplina(e.target.value)} style={{ flexGrow: 1 }} />
            <Button variant="outline-success" onClick={() => addItem("discipline", newDisciplina)}>+</Button>
          </div>
          <div className="mb-4">
            {formData.discipline.map((disc, i) => (
              <Badge key={i} bg="success" className="me-2 mb-2" style={{ cursor: "pointer", fontSize: "1rem" }} onClick={() => removeItem("discipline", i)}>
                {disc} ✕
              </Badge>
            ))}
          </div>

          <h5 className="text-secondary border-bottom pb-1 mb-3">Lista Atleti</h5>
          <div className="d-flex flex-wrap gap-2 mb-2">
            <Form.Control type="text" placeholder="Nome atleta" value={newAtleta} onChange={(e) => setNewAtleta(e.target.value)} style={{ flexGrow: 1 }} />
            <Button variant="outline-primary" onClick={() => addItem("lista_atleti", newAtleta)}>+</Button>
          </div>
          <div className="mb-4">
            {formData.lista_atleti.map((nome, i) => (
              <Badge key={i} bg="info" text="dark" className="me-2 mb-2" style={{ cursor: "pointer", fontSize: "1rem" }} onClick={() => removeItem("lista_atleti", i)}>
                {nome} ✕
              </Badge>
            ))}
          </div>

          <Form.Group className="mb-4">
            <Form.Check type="checkbox" label="Sono già affiliato ad un ente" name="gia_affiliato" checked={formData.gia_affiliato} onChange={handleChange} />
            {formData.gia_affiliato && (
              <Form.Control type="text" placeholder="Inserisci ente precedente" name="ente_precedente" value={formData.ente_precedente} onChange={handleChange} className="mt-2" />
            )}
          </Form.Group>

          <h5 className="text-secondary border-bottom pb-1 mb-2">Firma (anche su due righe)</h5>
          <div className="border rounded p-2 bg-light text-center">
            <canvas
              ref={canvasRef}
              onMouseDown={startDrawing}
              onMouseMove={draw}
              onMouseUp={endDrawing}
              onMouseLeave={endDrawing}
              onTouchStart={startDrawing}
              onTouchMove={draw}
              onTouchEnd={endDrawing}
              style={{ cursor: "crosshair", backgroundColor: "white", touchAction: "none", width: "100%", maxHeight: "300px" }}
            />
            <div className="mt-2 text-end">
              <Button size="sm" variant="outline-danger" onClick={clearCanvas}>Cancella Firma</Button>
            </div>
          </div>

          <Button
            type="button"
            className="w-100 mt-4"
            size="lg"
            variant="primary"
            disabled={loading}
            onClick={() => { setModalType("confirm"); setShowModal(true); }}
          >
            {loading ? "Invio..." : "Richiedi Affiliazione"}
          </Button>
        </Form>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        {modalType === "confirm" ? (
          <>
            <Modal.Header closeButton>
              <Modal.Title>Conferma Invio</Modal.Title>
            </Modal.Header>
            <Modal.Body>Sei sicuro di voler inviare la richiesta di affiliazione all'ente WKA?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Annulla</Button>
              <Button
                variant="primary"
                onClick={() => {
                  setShowModal(false);
                  // apri loading e invia
                  setLoading(true);
                  // esegui submit e, in caso di successo, modal di success verrà mostrato dalla funzione stessa
                  handleSubmit().finally(() => setLoading(false));
                }}
              >
                Conferma
              </Button>
            </Modal.Footer>
          </>
        ) : (
          <>
            <Modal.Header closeButton>
              <Modal.Title>Richiesta Inviata</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p><strong>Ben fatto!</strong> La tua richiesta è andata a buon fine.</p>
              <p>Per completare la richiesta servirà versare il contributo tramite bonifico bancario:</p>

              {modalMessage && (
                <Alert variant="success" className="mt-2 mb-3 py-1 text-center">
                  {modalMessage}
                </Alert>
              )}

              <Card className="p-3 mb-3">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <div className="small text-muted">Intestatario</div>
                    <div className="fw-bold">{BANK_DETAILS.beneficiario}</div>
                  </div>
                  <Button size="sm" variant="outline-secondary" onClick={() => copyToClipboard(BANK_DETAILS.beneficiario)}>Copia</Button>
                </div>

                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <div className="small text-muted">Banca</div>
                    <div className="fw-bold">{BANK_DETAILS.banca}</div>
                  </div>
                  <Button size="sm" variant="outline-secondary" onClick={() => copyToClipboard(BANK_DETAILS.banca)}>Copia</Button>
                </div>

                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div style={{ wordBreak: "break-all" }}>
                    <div className="small text-muted">IBAN</div>
                    <div className="fw-bold">{BANK_DETAILS.iban}</div>
                  </div>
                  <div className="d-flex gap-2">
                    <Button size="sm" variant="outline-secondary" onClick={() => copyToClipboard(BANK_DETAILS.iban)}>Copia</Button>
                    <Button size="sm" variant="outline-secondary" onClick={() => downloadBonifico(getBonificoText(causaleForModal))}>Scarica .txt</Button>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-start mb-2">
                  <div>
                    <div className="small text-muted">Importo</div>
                    <div className="fw-bold">€ {BANK_DETAILS.importo}</div>
                  </div>
                  <Button size="sm" variant="outline-secondary" onClick={() => copyToClipboard(BANK_DETAILS.importo)}>Copia</Button>
                </div>

                <div className="d-flex justify-content-between align-items-start">
                  <div style={{ wordBreak: "break-all" }}>
                    <div className="small text-muted">Causale</div>
                    <div className="fw-bold">{causaleForModal}</div>
                  </div>
                  <div className="d-flex gap-2">
                    <Button size="sm" variant="outline-secondary" onClick={() => copyToClipboard(causaleForModal)}>Copia</Button>
                    <Button size="sm" variant="outline-secondary" onClick={() => downloadBonifico(getBonificoText(causaleForModal))}>Scarica .txt</Button>
                  </div>
                </div>
              </Card>

              <p className="small text-muted">Dopo il bonifico invia copia della ricevuta via email all'indirizzo eventi.freesport@gmail.com</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>Chiudi</Button>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </Container>
  );
}
